<template>
    <div>
        <b>{{cartItem.quantity}}x {{product.name}} <template v-if="product.variant">&bull; {{product.variant.name}}</template></b>
    </div>
</template>

<script>
export default {
    props: ["product", 'cartItem', "popup"]
}
</script>